export class StatusError extends Error {
	constructor(status: number) {
		super(`Response has error status: ${status}`)
		this.name = 'StatusError'
	}
}

export class UnexpectedContentTypeError extends Error {
	constructor(contentType: string) {
		super(`Response has unexpected content type: ${contentType}`)
		this.name = 'UnexpectedContentTypeError'
	}
}

export function checkStatus(response: Response) {
	// if (response.status !== 200)
	if (response.status >= 400) throw new StatusError(response.status)
	return response
}
